import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { CartUpdateEvent, ThemeEvents } from '@theme/events';
import { DialogComponent, DialogCloseEvent } from '@theme/dialog';
import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

export class QuickAddComponent extends Component {
  /** @type {AbortController | null} */
  #abortController = null;
  /** @type {Document | null} */
  #cachedProductHtml = null;

  get cachedProductHtml() {
    return this.#cachedProductHtml;
  }

  get productPageUrl() {
    return /** @type {HTMLAnchorElement} */ (this.closest('product-card')?.querySelector('a[ref="productCardLink"]'))
      ?.href;
  }

  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#closeQuickAddModal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    mediaQueryLarge.removeEventListener('change', this.#closeQuickAddModal);
  }

  /**
   * Handles quick add button click
   * @param {Event} event - The click event
   */
  handleClick = async (event) => {
    event.preventDefault();

    if (!this.#cachedProductHtml) {
      await this.fetchProductPage(this.productPageUrl);
    }

    if (this.#cachedProductHtml) {
      // Create a fresh copy of the cached HTML to avoid modifying the original
      const freshHtmlCopy = new DOMParser().parseFromString(
        this.#cachedProductHtml.documentElement.outerHTML,
        'text/html'
      );

      await this.updateQuickAddModal(freshHtmlCopy);
    }

    this.#openQuickAddModal();
  };

  /** @param {QuickAddDialog} dialogComponent */
  #stayVisibleUntilDialogCloses(dialogComponent) {
    this.toggleAttribute('stay-visible', true);

    dialogComponent.addEventListener(DialogCloseEvent.eventName, () => this.toggleAttribute('stay-visible', false), {
      once: true,
    });
  }

  #openQuickAddModal = () => {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;

    this.#stayVisibleUntilDialogCloses(dialogComponent);

    dialogComponent.showDialog();
    const variantPicker = document.querySelector("variant-picker");

    // Whenever any variant changes (e.g., Density), we validate Style
    if(variantPicker){
    // document.querySelectorAll(".variant-Density .variant-option__button-label").forEach((button) => {
    //   button.addEventListener("click", () => {
    //     // Delay to wait for DOM updates (you can also use MutationObserver)
    //     setTimeout(() => {
    //       const styleRadios = document.querySelectorAll('.variant-Style input[type="radio"]');
    //       //console.log("radio");
    //       // Find the first available style option
    //       let found = false;
    //       for (let i = 0; i < styleRadios.length; i++) {
    //         const radio = styleRadios[i];
    
    //         // Make sure it's visible (not just present) and available
    //         const isAvailable = radio.dataset.optionAvailable === "true";
    //         const isHidden = window.getComputedStyle(radio.closest('.variant-option__item') ?? radio).display === "none";
    
    //         if (isAvailable && !isHidden) {
    //           radio.checked = true;
    //           //console.log("checked");
    //           // Trigger a real 'change' event so Shopify JS picks it up
    //           radio.dispatchEvent(new Event("change", { bubbles: true }));
    
    //           // Optional: update variantPicker manually (if needed)
    //           if (variantPicker) {
    //             variantPicker.updateSelectedOption(radio);
    //           }
    
    //           found = true;
    //           break;
    //         }
    //       }
    
    //       if (!found) {
    //         console.warn("No available Style variant found");
    //       }
    //     }, 2500);
    //   });
    // });

    const variantPicker = document.querySelector("variant-picker");

// Whenever any variant changes (e.g., Density), we validate Style
document.querySelectorAll(".variant-option__button-label").forEach((button) => {
  button.addEventListener("click", () => {
    // Delay to wait for DOM updates (you can also use MutationObserver)
    setTimeout(() => {
      const nextSibling = button.parentElement.parentElement.nextElementSibling;
      if(nextSibling){
       // const styleRadios = nextSibling.querySelectorAll('input[type="radio"]');
     
      const styleRadios = nextSibling.querySelectorAll('input[type="radio"]');
      //console.log("radio");
      // Find the first available style option

      const currentlySelectedRadio = nextSibling.querySelector('input[type="radio"]:checked');
        
        // Check if the currently selected radio button is available and visible
        let isCurrentlyAvailable = false;
        if (currentlySelectedRadio) {
          const isAvailable = currentlySelectedRadio.dataset.optionAvailable === "true";
          const isHidden = window.getComputedStyle(currentlySelectedRadio.closest('.variant-option__item') ?? currentlySelectedRadio).display === "none";
          isCurrentlyAvailable = isAvailable && !isHidden;
        }
        if (!isCurrentlyAvailable) {

      let found = false;
      for (let i = 0; i < styleRadios.length; i++) {
        const radio = styleRadios[i];

        // Make sure it's visible (not just present) and available
        const isAvailable = radio.dataset.optionAvailable === "true";
        const isHidden = window.getComputedStyle(radio.closest('.variant-option__item') ?? radio).display === "none";

        if (isAvailable && !isHidden) {
          radio.checked = true;
          //console.log("checked");
          // Trigger a real 'change' event so Shopify JS picks it up
          radio.dispatchEvent(new Event("change", { bubbles: true }));

          // Optional: update variantPicker manually (if needed)
          if (variantPicker) {
            variantPicker.updateSelectedOption(radio);
          }

          found = true;
          break;
        }
      }

      if (!found) {
        console.warn("No available Style variant found");
      }
    }
    }
    }, 2500);
  });
});
    }

  };

  #closeQuickAddModal = () => {
    const dialogComponent = document.getElementById('quick-add-dialog');
    if (!(dialogComponent instanceof QuickAddDialog)) return;

    dialogComponent.closeDialog();
  };

  /**
   * Fetches the product page content
   * @param {string} productPageUrl - The URL of the product page to fetch
   * @returns {Promise<void>}
   * @throws {Error} If the fetch request fails or returns a non-200 response
   */
  async fetchProductPage(productPageUrl) {
    if (!productPageUrl) return;

    // We use this to abort the previous fetch request if it's still pending.
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    try {
      const response = await fetch(productPageUrl, {
        signal: this.#abortController.signal,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product page: HTTP error ${response.status}`);
      }

      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      // Store the HTML for later use
      this.#cachedProductHtml = html;
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      } else {
        throw error;
      }
    } finally {
      this.#abortController = null;
    }
  }

  /**
   * Re-renders the variant picker.
   * @param {Document} newHtml - The new HTML.
   */
  async updateQuickAddModal(newHtml) {
    const productGrid = newHtml.querySelector('[data-product-grid-content]');
    const modalContent = document.getElementById('quick-add-modal-content');

    if (!productGrid || !modalContent) return;

    if (isMobileBreakpoint()) {
      const productDetails = productGrid.querySelector('.product-details');
      if (!productDetails) return;
      const productFormComponent = productGrid.querySelector('product-form-component');
      const variantPicker = productGrid.querySelector('variant-picker');
      const productPrice = productGrid.querySelector('product-price');
      const productdescription = productGrid.querySelector('product-description');
      const productTitle = document.createElement('a');
      productTitle.textContent = this.dataset.productTitle || '';

      // Make product title as a link to the product page
      productTitle.href = this.productPageUrl;

      if (!productFormComponent || !productPrice || !productTitle || !productdescription) return;

      const productHeader = document.createElement('div');
      productHeader.classList.add('product-header');

      productHeader.appendChild(productTitle);
      productHeader.appendChild(productPrice);
      productGrid.appendChild(productHeader);
      productGrid.appendChild(productdescription);
      if(variantPicker){
        productGrid.appendChild(variantPicker);
      }
      productGrid.appendChild(productFormComponent);
      productDetails.remove();
    }

    morph(modalContent, productGrid);
  }
}

if (!customElements.get('quick-add-component')) {
  customElements.define('quick-add-component', QuickAddComponent);
}

class QuickAddDialog extends DialogComponent {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate, { signal: this.#abortController.signal });
    this.addEventListener(ThemeEvents.variantUpdate, this.#updateProductTitleLink);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
  }

  /**
   * Closes the dialog
   * @param {CartUpdateEvent} event - The cart update event
   */
  handleCartUpdate = (event) => {
    if (event.detail.data.didError) return;
    this.closeDialog();
  };

  #updateProductTitleLink = (/** @type {CustomEvent} */ event) => {
    const anchorElement = /** @type {HTMLAnchorElement} */ (
      event.detail.data.html?.querySelector('.view-product-title a')
    );
    const viewMoreDetailsLink = /** @type {HTMLAnchorElement} */ (this.querySelector('.view-product-title a'));
    const mobileProductTitle = /** @type {HTMLAnchorElement} */ (this.querySelector('.product-header a'));

    if (!anchorElement) return;

    if (viewMoreDetailsLink) viewMoreDetailsLink.href = anchorElement.href;
    if (mobileProductTitle) mobileProductTitle.href = anchorElement.href;
  };
}

if (!customElements.get('quick-add-dialog')) {
  customElements.define('quick-add-dialog', QuickAddDialog);
}
